import Input from '../../components/Input';
import React, { useEffect, useReducer, useState } from 'react';
import { useUser } from '../../contexts/UserContext';
import { useTranslation } from 'next-i18next';
import Box from 'reusecore/src/elements/Box';
import Button from 'reusecore/src/elements/Button';
import colors from '../../theme/colors';
import { useMutation } from '@apollo/client';
import { ADD_REVIEW } from '@core/ui/graphql/Mutations';
import RateStars from '../../components/RateStars';
import { RateInputsWrapper, AddReviewModalTitle } from './style';

const initState = {
  title: '',
  message: '',
  communication: 1,
  punctuality: 1,
  quality: 1,
  global: 1,
  status: true,
  id: null,
  reviewedUserId: null,
  reviewedAlternateName: '',
  creatorAlternateName: '',
  creatorCertified: false,
  createdAt: '',
};

const reviewReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_REVIEW':
      let values = action.payload;
      let newState = {
        ...state,
        ...values,
      };
      newState.global =
        (newState.communication + newState.punctuality + newState.quality) / 3;
      return newState;
    case 'CREATE_REVIEW':
      return initState;
    default:
      return state;
  }
};

const AddReview = props => {
  const { t } = useTranslation();
  const [state, dispatch] = useReducer(reviewReducer, initState);
  const [publishBtnLoading, setPublishBtnLoading] = useState(false);

  const { title, message, communication, punctuality, quality } = state;

  const { state: { certified, alternateName } = {} } = useUser();

  const {
    data: {
      uid: reviewedUserId = '',
      title: modalTitle,
      closeModal,
      handleAddReview,
    } = {},
  } = props;

  const [reviewMutation] = useMutation(ADD_REVIEW);

  useEffect(() => {
    dispatch({ type: 'CREATE_REVIEW' });
  }, []);

  const handleReviewSubmit = async () => {
    setPublishBtnLoading(true);
    dispatch({
      type: 'UPDATE_REVIEW',
      payload: {
        createdAt: true,
        reviewedUserId: reviewedUserId,
        creatorAlternateName: alternateName,
        creatorCertified: certified,
      },
    });

    finalData.createdAt = true;
    finalData.reviewedUserId = reviewedUserId;
    finalData.creatorAlternateName = alternateName;
    finalData.creatorCertified = certified;

    const data = await reviewMutation({
      variables: {
        review: finalData,
      },
    });

    setPublishBtnLoading(false);
    dispatch({ type: 'CREATE_REVIEW' });
    handleAddReview();
    closeModal();
  };

  let finalData = {
    ...initState,
    ...state,
  };

  return (
    <>
      <AddReviewModalTitle>{modalTitle}</AddReviewModalTitle>

      <RateInputsWrapper>
        <RateStars
          value={communication}
          name="communication"
          label={`${t('review.communication')}*`}
          size="44px"
          changed={communication =>
            dispatch({
              type: 'UPDATE_REVIEW',
              payload: { communication: parseInt(communication.target.value) },
            })
          }
          style={{
            marginTop: 20,
          }}
        />

        <RateStars
          value={punctuality}
          name="punctuality"
          label={`${t('review.punctuality')}*`}
          size="44px"
          changed={punctuality =>
            dispatch({
              type: 'UPDATE_REVIEW',
              payload: { punctuality: parseInt(punctuality.target.value) },
            })
          }
          style={{
            marginTop: 20,
          }}
        />

        <RateStars
          value={quality}
          name="quality"
          label={`${t('review.quality')}*`}
          size="44px"
          changed={quality =>
            dispatch({
              type: 'UPDATE_REVIEW',
              payload: { quality: parseInt(quality.target.value) },
            })
          }
          style={{
            marginTop: 20,
          }}
        />
      </RateInputsWrapper>

      <Input
        elementType="input"
        elementConfig={{
          type: 'text',
          required: 'required',
        }}
        label={`${t('review.modalAdd.titleInput')}*`}
        value={title}
        changed={title => {
          dispatch({
            type: 'UPDATE_REVIEW',
            payload: { title: title.target.value },
          });
        }}
        style={{
          marginTop: 20,
        }}
      />
      <Input
        elementType="textarea"
        rows={'auto'}
        minRows={4}
        maxRows={15}
        elementConfig={{
          type: 'text',
          required: 'required',
          maxLength: '255',
        }}
        label={`${t('review.modalAdd.messageInput')}*`}
        value={message}
        changed={details =>
          dispatch({
            type: 'UPDATE_REVIEW',
            payload: { message: details.target.value },
          })
        }
        style={{
          marginTop: 20,
        }}
      />
      <Box flexBox justifyContent="space-between">
        <Button
          title={t('publish')}
          isLoading={publishBtnLoading}
          loaderColor="#ffffff"
          onClick={handleReviewSubmit}
          disabled={message === '' || title === '' || publishBtnLoading}
          style={{
            backgroundColor:
              message === '' || title === '' || publishBtnLoading
                ? `${colors.inactiveButton}`
                : `${colors.primary}`,
          }}
        />
      </Box>
    </>
  );
};

export default AddReview;
